import { useEffect } from 'react';
import getFileNameAndExtension from '@uppy/utils/lib/getFileNameAndExtension';

import { useFileBufferContext } from '@lyearn/lygo-core';
import { Uppy } from '@lyearn/shared/hooks/useUppy';

const DropSource = 'DragDrop';
const useDrop = (node: any, updateAttrs: (attrs: Object) => void, uppy: Uppy | null) => {
  const { fileBuffer } = useFileBufferContext();
  useEffect(() => {
    if (node?.attrs.file) {
      const dropFile = fileBuffer?.getFile(node?.attrs.file) as File;
      if (dropFile) {
        const descriptors = [dropFile].map((file: any) => {
          const { name, extension } = getFileNameAndExtension(file.name);

          const modifiedFile = new File([file], `${name}_${new Date().getTime()}.${extension}`, {
            type: file.type,
          });

          return {
            source: DropSource,
            name: file.name,
            type: modifiedFile.type,
            data: modifiedFile,
            meta: {
              relativePath: (file as any).relativePath,
              shortId: node?.attrs.id,
            },
          };
        });

        try {
          uppy?.addFiles(descriptors);
        } catch (err) {
          console.log(err);
        }
      }

      fileBuffer?.removeFile(node?.attrs.file);
      updateAttrs({ file: null });
    }
  }, [fileBuffer, node, updateAttrs, uppy]);
};

export default useDrop;
